import { createSlice } from '@reduxjs/toolkit';

import store from './store';

import endPoints from '../api/endpoint';
import { getApiCall, postApiCall, putApiCall } from '../api/methods';
import { notify } from '../Utils/toastify';

import { StoreState } from '../types';
import { setCommonDataLoader } from './commonSlice';

const initialState: StoreState = {
  loading: false,
  productLoading: false,
  packageLoading: false,
  vendorLoading: false,
  serviceLoading: false,
  deptsCategories: {},
  preferredVendors: {},
  preferredProducts: {},
  preferredServies: {},
  vendors: {},
  products: {},
  services: {},
  packages: {},
  favorites: {},
  selectedAddress: {},
  preferredPackages: {},
  productDetails: {},
  favoriteData: {},
  serviceDetails: {},
  vendorDetails: {},
  vendorAllDetails: {},
  vendorDetailsGroups: {},
  vendorProducts: {},
  packageDetails: {},
  vendorServices: {},
  groupProducts: {},
  groupServices: {},
  groupPackages: {},
  storeBanner: {},
  deptsIDs: '',
};

const storeSlice = createSlice({
  name: 'store',
  initialState,
  reducers: {
    updateLoader: (state: any, action: any) => {
      const { payload }: any = action;
      state.loading = payload;
    },
    updateDepartmentCategoires: (state: any, action: any) => {
      const { payload }: any = action;
      state.deptsCategories = payload;
    },
    updatePreferredVendors: (state: any, action: any) => {
      const { payload }: any = action;
      state.preferredVendors = payload;
    },
    updateVendors: (state: any, action: any) => {
      const { payload }: any = action;
      state.vendors = payload;
    },
    setproductDetails: (state: any, action: any) => {
      const { payload }: any = action;
      state.productDetails = payload;
    },
    setServiceDetails: (state: any, action: any) => {
      const { payload }: any = action;
      state.serviceDetails = payload;
    },
    setPacakgeDetails: (state: any, action: any) => {
      const { payload }: any = action;
      state.packageDetails = payload;
    },
    setVendorDetails: (state: any, action: any) => {
      const { payload }: any = action;
      state.vendorDetails = payload;
    },
    setVendorProducts: (state: any, action: any) => {
      const { payload }: any = action;
      state.vendorProducts = payload;
    },
    setVendorServices: (state: any, action: any) => {
      const { payload }: any = action;
      state.vendorServices = payload;
    },
    setVendorAllDetails: (state: any, action: any) => {
      const { payload }: any = action;
      state.vendorAllDetails = payload;
    },
    setVendorDetailGroups: (state: any, action: any) => {
      const { payload }: any = action;
      state.vendorDetailsGroups = payload;
    },
    updatePreferredProducts: (state: any, action: any) => {
      const { payload }: any = action;
      state.preferredProducts = payload;
    },
    updatePreferredServices: (state: any, action: any) => {
      const { payload }: any = action;
      state.preferredServies = payload;
    },

    updateProducts: (state: any, action: any) => {
      const { payload }: any = action;
      state.products = payload;
    },
    updateServices: (state: any, action: any) => {
      const { payload }: any = action;
      state.services = payload;
    },
    updatePackages: (state: any, action: any) => {
      const { payload }: any = action;
      state.packages = payload;
    },
    updateSelectedAddresses: (state: any, action: any) => {
      const { payload }: any = action;
      state.selectedAddress = payload;
    },
    updatePreferredPackages: (state: any, action: any) => {
      const { payload }: any = action;
      state.preferredPackages = payload;
    },
    updateFavorites: (state: any, action: any) => {
      const { payload }: any = action;
      state.favoriteData = payload;
    },
    setGroupProducts: (state: any, action: any) => {
      const { payload }: any = action;
      state.groupProducts = payload;
    },
    setGroupServices: (state: any, action: any) => {
      const { payload }: any = action;
      state.groupServices = payload;
    },
    setGroupPackages: (state: any, action: any) => {
      const { payload }: any = action;
      state.groupPackages = payload;
    },
    setStoreBanner: (state: any, action: any) => {
      const { payload }: any = action;
      state.storeBanner = payload;
    },
    setProductLoading: (state: any, action: any) => {
      const { payload }: any = action;
      state.productLoading = payload;
    },
    setPackageLoading: (state: any, action: any) => {
      const { payload }: any = action;
      state.packageLoading = payload;
    },
    setServiceLoading: (state: any, action: any) => {
      const { payload }: any = action;
      state.serviceLoading = payload;
    },
    setVendorLoading: (state: any, action: any) => {
      const { payload }: any = action;
      state.vendorLoading = payload;
    },
    setDeptsIDs: (state: any, action: any) => {
      const { payload }: any = action;
      state.deptsIDs = payload;
    },
  },
});

export const {
  updateLoader,
  updateDepartmentCategoires,
  updatePreferredVendors,
  updateVendors,
  updatePreferredProducts,
  updatePreferredServices,
  updateProducts,
  updateServices,
  updatePackages,
  setproductDetails,
  updatePreferredPackages,
  updateFavorites,
  setServiceDetails,
  setVendorDetails,
  setVendorProducts,
  setVendorServices,
  setVendorAllDetails,
  setPacakgeDetails,
  setVendorDetailGroups,
  setGroupProducts,
  setGroupServices,
  setGroupPackages,
  setStoreBanner,
  setPackageLoading,
  setProductLoading,
  setServiceLoading,
  setVendorLoading,
  setDeptsIDs,
  //   updateSelectedAddresses,
} = storeSlice.actions;

export default storeSlice.reducer;

// API Calls

export const getDepartmentCategories = (
  page = 1,
  limit = 6,
  setHasNextPage?: any,
  cb?: any,
  latitude?: number | string,
  longitude?: number | string,
  // setHasPrevPage?: any
) => {
  const { dispatch } = store;
  let query = `?page=${page}&limit=${limit}`;
  if (latitude !== undefined && longitude !== undefined) {
    query += `&latitude=${latitude}&longitude=${longitude}`;
  }

  dispatch(setCommonDataLoader(true)); // Show loader before the API call

  getApiCall(
    `${endPoints.store.userDepartmentsCategories}${query}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(updateDepartmentCategoires(data.data));
        dispatch(
          setDeptsIDs(
            data.data?.userDeptList?.map((dept: any) => dept?._id).join(','),
          ),
        );

        setHasNextPage(page * limit < data?.data?.userDeptCategoryCount);
        if (cb) cb(); // Call the callback function if provided
      }
      dispatch(setCommonDataLoader(false)); // Hide loader after successful response
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
      dispatch(setCommonDataLoader(false)); // Hide loader after error
    },
  );
};

export const getPreferredApi = (
  type: string,
  query = '?page=1&limit=10',
  cb?: any,
) => {
  const { dispatch, getState } = store;
  console.log('called', type);
  const apiEndPoint = `${
    endPoints.store.preferredVendors + query
  }&itemType=${type}`;
  dispatch(updateLoader(true)); // Show loader before API call

  getApiCall(
    apiEndPoint,
    (s: any) => {
      const { data } = s;

      if (data.data) {
        // Extract page number from query (default to 1 if not present)
        const pageMatch = query.match(/page=(\d+)/);
        const currentPage = pageMatch ? parseInt(pageMatch[1], 10) : 1;

        // Get existing data from Redux state
        const existingState =
          getState().store[
            type === 'branch'
              ? 'preferredVendors'
              : type === 'product'
              ? 'preferredProducts'
              : type === 'service'
              ? 'preferredServices'
              : 'preferredPackages'
          ] || {};

        // Merge data without duplicates using a Map
        const mergedData =
          currentPage === 1
            ? data?.data?.myFavData || data?.data?.data
            : [...(existingState?.myFavData || []), ...data.data.myFavData];

        // Remove duplicates based on _id
        const uniqueData = Array.from(
          new Map(mergedData.map((item: any) => [item._id, item])).values(),
        );

        // Update preferredIds accordingly
        const updatedPreferredIds = uniqueData.map((item: any) => item._id);

        const payload = {
          ...data.data,
          myFavData: uniqueData,
          preferredIds: updatedPreferredIds,
        };

        // Dispatch update based on type
        if (type === 'branch') {
          console.log('called', payload, type);
          dispatch(updatePreferredVendors(payload));
        } else if (type === 'product') {
          dispatch(updatePreferredProducts(payload));
        } else if (type === 'service') {
          dispatch(updatePreferredServices(payload));
        } else if (type === 'package') {
          dispatch(updatePreferredPackages(payload));
        }

        if (cb) cb(data.data); // Trigger callback if provided
      }

      dispatch(updateLoader(false)); // Hide loader after successful response
    },
    (e: any) => {
      console.error('Error fetching preferred items:', e);
      dispatch(updateLoader(false)); // Hide loader after error
    },
  );
};

export const getVendors = (query = '?page=1&limit=10', cb?: any) => {
  const { dispatch } = store;

  const apiEndPoint = endPoints.store.vendorsList + query;
  dispatch(updateLoader(true)); // Show loader before the API call
  dispatch(setVendorLoading(true)); // Show loader before the API call

  getApiCall(
    apiEndPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(updateVendors(data.data));

        if (cb) cb(data?.data?.data); // Call the callback function if provided
      }
      dispatch(updateLoader(false)); // Hide loader after successful response
      dispatch(setVendorLoading(false)); // Show loader before the API call
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);

      dispatch(updateLoader(false)); // Hide loader after error
      dispatch(setVendorLoading(false)); // Show loader before the API call
    },
  );
};

export const getProducts = (
  query = '?page=1&limit=10',
  cb?: any,
  deptId?: any,
) => {
  const { dispatch } = store;

  const apiEndPoint =
    endPoints.store.products + query + (deptId ? `&department=${deptId}` : '');

  dispatch(updateLoader(true)); // Show loader before the API call

  dispatch(setProductLoading(true)); // Show loader before the API call

  getApiCall(
    apiEndPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(updateProducts(data.data));

        if (cb) cb(data.data.data); // Call the callback function if provided
      }
      dispatch(updateLoader(false)); // Hide loader after successful response

      dispatch(setProductLoading(false)); // Show loader before the API call
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);

      dispatch(updateLoader(false)); // Hide loader after error

      dispatch(setProductLoading(false)); // Show loader before the API call
    },
  );
};

export const getServices = (
  query = '?page=1&limit=10',
  cb?: any,
  deptId?: any,
) => {
  const { dispatch } = store;

  const apiEndPoint =
    endPoints.store.services + query + (deptId ? `&department=${deptId}` : '');
  dispatch(updateLoader(true)); // Show loader before the API call

  dispatch(setServiceLoading(true)); // Show loader before the API call

  getApiCall(
    apiEndPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(updateServices(data.data));

        if (cb) cb(data.data.data); // Call the callback function if provided
      }
      dispatch(updateLoader(false)); // Hide loader after successful response

      dispatch(setServiceLoading(false)); // Show loader before the API call
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);

      dispatch(updateLoader(false)); // Hide loader after error

      dispatch(setServiceLoading(false)); // Show loader before the API call
    },
  );
};

export const getPackages = (
  query = '?page=1&limit=10',
  cb?: any,
  deptId?: any,
  searchkey?: any,
) => {
  const { dispatch } = store;

  let apiEndPoint =
    endPoints.store.packages + query + (deptId ? `&department=${deptId}` : '');
  if (searchkey) {
    apiEndPoint += `&searchKey=${searchkey}`;
  }
  dispatch(updateLoader(true)); // Show loader before the API call

  dispatch(setPackageLoading(true)); // Show loader before the API call

  getApiCall(
    apiEndPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(updatePackages(data.data));

        if (cb) cb(data.data.data); // Call the callback function if provided
      }
      dispatch(updateLoader(false)); // Hide loader after successful response

      dispatch(setPackageLoading(false)); // Show loader before the API call
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);

      dispatch(updateLoader(false)); // Hide loader after error

      dispatch(setPackageLoading(false)); // Show loader before the API call
    },
  );
};

export const addToFavorites = (values: any, cb?: any) => {
  postApiCall(
    endPoints.store.addToFavorites,
    values,
    (s: any) => {
      const {
        data: { statusCode, msg },
      } = s;

      if (statusCode && statusCode === 200) {
        notify(msg, 'success');
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
  // }
};

// export const setSelectedAddress = (address: any = {}) => {
//   const { dispatch } = store

//   console.log('ADDRESS =>', address)

//   dispatch(updateSelectedAddresses(address))
// }
export const getProductDetails = (productId?: any, cb?: any) => {
  const { dispatch } = store;

  const apiEndPoint = endPoints.getProductDetails + productId;
  dispatch(updateLoader(true)); // Show loader before the API call

  getApiCall(
    apiEndPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setproductDetails(data.data));

        if (cb) cb(data.data); // Call the callback function if provided
      }
      dispatch(updateLoader(false)); // Hide loader after successful response
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);

      dispatch(updateLoader(false)); // Hide loader after error
    },
  );
};

export const getGroupDetails = (
  groupId?: any,
  type?: any,
  searchKey?: any,
  cb?: any,
) => {
  const { dispatch } = store;

  let apiEndPoint = `${endPoints.store.groupDetail + groupId}?itemType=${type}`;
  if (searchKey) {
    apiEndPoint += `&searchKey=${searchKey}`;
  }

  dispatch(setCommonDataLoader(true)); // Show loader before the API call

  getApiCall(
    apiEndPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        // Check type and dispatch accordingly
        if (type === 'SERVICE') {
          dispatch(setGroupServices(data.data)); // <- if SERVICE
        } else if (type === 'PACKAGE') {
          dispatch(setGroupPackages(data.data)); // <- if PACKAGE
        } else if (type === 'PRODUCT') {
          dispatch(setGroupProducts(data.data)); // <- if PRODUCT
        } else {
          // Default dispatch if type is unknown (optional)
          dispatch(setproductDetails(data.data));
        }

        if (cb) cb(data.data); // Call the callback function if provided
      }
      dispatch(setCommonDataLoader(false)); // Hide loader after successful response
    },
    (e: any) => {
      console.error('Error fetching production details:', e);
      dispatch(setCommonDataLoader(false)); // Hide loader after error
    },
  );
};

export const getServiceDetailPage = (productId?: any, cb?: any) => {
  const { dispatch } = store;

  const apiEndPoint = endPoints.store.getserviceDetails + productId;
  dispatch(updateLoader(true)); // Show loader before the API call

  getApiCall(
    apiEndPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setServiceDetails(data.data));

        if (cb) cb(data.data); // Call the callback function if provided
      }
      dispatch(updateLoader(false)); // Hide loader after successful response
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);

      dispatch(updateLoader(false)); // Hide loader after error
    },
  );
};

export const getPackageDetailPage = (pacakgeId?: any, cb?: any) => {
  const { dispatch } = store;

  const apiEndPoint = endPoints.store.getPacakgeDetails + pacakgeId;
  dispatch(setCommonDataLoader(true)); // Show loader before the API call
  dispatch(updateLoader(true));
  getApiCall(
    apiEndPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setPacakgeDetails(data.data));

        if (cb) cb(data.data); // Call the callback function if provided
      }
      dispatch(setCommonDataLoader(false));
      dispatch(updateLoader(false)); // Hide loader after successful response
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
      notify(e?.data?.message, 'error');
      dispatch(setCommonDataLoader(false)); // Hide loader after error
    },
  );
};

export const getVendorDetails = (productId?: any, cb?: any) => {
  const { dispatch } = store;

  const apiEndPoint = endPoints.store.getVendorDetailsCategories + productId;
  dispatch(updateLoader(true)); // Show loader before the API call

  getApiCall(
    apiEndPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setVendorDetails(data.data));

        if (cb) cb(data.data); // Call the callback function if provided
      }
      dispatch(updateLoader(false)); // Hide loader after successful response
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);

      dispatch(updateLoader(false)); // Hide loader after error
    },
  );
};

export const getVendorDetailsGroups = (productId?: any, cb?: any) => {
  const { dispatch } = store;

  const apiEndPoint = `${endPoints.store.getVendorDetailGrops}?branchId=${productId}`;
  dispatch(updateLoader(true)); // Show loader before the API call

  getApiCall(
    apiEndPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setVendorDetailGroups(data.data));

        if (cb) cb(data.data); // Call the callback function if provided
      }
      dispatch(updateLoader(false)); // Hide loader after successful response
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);

      dispatch(updateLoader(false)); // Hide loader after error
    },
  );
};
export const getVendorProductsPage = (
  productId?: any,
  query?: string,
  cb?: any,
  searchKey?: any,
) => {
  const { dispatch } = store;

  let apiEndPoint = `${endPoints.store.getVendorDetailProducts}?branchId=${productId}`;

  if (searchKey) {
    apiEndPoint += `&searchKey=${searchKey}`;
  }

  if (query) {
    apiEndPoint += query;
  }

  dispatch(updateLoader(true)); // Show loader before the API call

  getApiCall(
    apiEndPoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setVendorProducts(data.data));

        if (cb) cb(data.data); // Call the callback function if provided
      }
      dispatch(updateLoader(false)); // Hide loader after successful response
    },
    (e: any) => {
      console.error('Error fetching production details:', e);

      dispatch(updateLoader(false)); // Hide loader after error
    },
  );
};

export const getVendorServicesPage = (productId?: any, cb?: any) => {
  const { dispatch } = store;

  const apiEndPoint = `${endPoints.store.getVendorDetailServices}?branchId=${productId}`;
  dispatch(updateLoader(true)); // Show loader before the API call

  getApiCall(
    apiEndPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setVendorServices(data.data));

        if (cb) cb(data.data); // Call the callback function if provided
      }
      dispatch(updateLoader(false)); // Hide loader after successful response
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);

      dispatch(updateLoader(false)); // Hide loader after error
    },
  );
};
export const getVendorAllDetails = (productId?: any, cb?: any) => {
  const { dispatch } = store;

  const apiEndPoint = `${endPoints.store.getVendorDetails}?vendorId=${productId}`;
  dispatch(updateLoader(true)); // Show loader before the API call

  getApiCall(
    apiEndPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setVendorAllDetails(data.data));

        if (cb) cb(data.data); // Call the callback function if provided
      }
      dispatch(updateLoader(false)); // Hide loader after successful response
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);

      dispatch(updateLoader(false)); // Hide loader after error
    },
  );
};

export const addDeparment = (values: any, cb?: any) => {
  putApiCall(
    endPoints.store.addDeparment,
    values,
    (s: any) => {
      const {
        data: { statusCode, msg },
      } = s;

      if (statusCode && statusCode === 200) {
        notify(msg, 'success');
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
  // }
};

//

export const getStoreBanner = () => {
  const { dispatch } = store;

  const apiEndPoint = endPoints.banner.getShopBanner;
  // dispatch(updateLoader(true)); // Show loader before the API call

  getApiCall(
    apiEndPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setStoreBanner(data.data));

        // if (cb) cb(data?.data?.data); // Call the callback function if provided
      }
      // dispatch(updateLoader(false)); // Hide loader after successful response
    },
    (e: any) => {
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);

      // dispatch(updateLoader(false)); // Hide loader after error
    },
  );
};

export const vendorRequest = (values: any, cb?: any) => {
  postApiCall(
    endPoints.store.vendorRequest,
    values,
    (s: any) => {
      const {
        data: { statusCode, msg },
      } = s;

      if (statusCode && statusCode === 200) {
        notify('Success', 'success');
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const handleDeptsIDs = (deptsIDs: any) => {
  const { dispatch } = store;

  console.log(deptsIDs, 'deptsIDs');

  dispatch(setDeptsIDs(deptsIDs));
};
